import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../services/authentication.service';
import { Player } from '../../../../models/player';
import { FormGroup, FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { PERMISSIONS } from '../../../../models/constants';

@Component({
  selector: 'app-manage-permissions',
  standalone: true,
  imports: [FormsModule, NgFor],
  templateUrl: './manage-permissions.component.html',
  styleUrl: './manage-permissions.component.css'
})
export class ManagePermissionsComponent implements OnInit {
  constructor(private authenticationService:AuthenticationService) {}

  form!: FormGroup;
  players:Array<Player>|null = null;
  selectedUsername:string|null = null;
  allPermissions:Array<string> = [];
  userPermissions:Array<SelectedPermissionViewModel> = []

  async ngOnInit() {
    for (const value of Object.values(PERMISSIONS))
      this.allPermissions.push(value);
    
    this.players = await this.authenticationService.getAllPlayers();
    let stop = true;
  }

  async getPermissionsForSelectedUser() {
    if(!this.selectedUsername) return;
    this.userPermissions = [];
    let permissions = await this.authenticationService.getPermissionsForUser(this.selectedUsername);
    this.allPermissions.forEach(element => {
      let up = permissions.find(p => p.permission.toLowerCase() === element.toLowerCase())
      this.userPermissions.push({id: up ? up.id : null, permission: element, isSelected: up ? true : false});
    });
  }

  async onSelectionChange(permission: SelectedPermissionViewModel) {
    if(!this.selectedUsername) return;

    if(permission.isSelected) {
      let id = await this.authenticationService.addPermission(this.selectedUsername, permission.permission);
      permission.id = id;
    }
    else {
      if(permission.id)
        await this.authenticationService.removePermission(permission.id);
    }
  }
}

interface SelectedPermissionViewModel {
  id:number|null,
  permission:string,
  isSelected:boolean
}
